module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon06.b95e4397.svg";